import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import PartialText from "app/pages/sales-intelligence/pages/company-analysis/components/shared/PartialText/PartialText";

import { StyledShowMoreButton } from "./styles";

const Description = ({ description }: { description?: string }) => {
    if (!description) {
        return null;
    };

    return (
        <Text
            fontVariant="input2"
            color={colorsPalettes.carbon[300]}
            data-automation="company-description-text"
        >
            <PartialText
                height={48}
                text={description}
                renderToggle={(isCollapsed, onToggle) => (
                    <StyledShowMoreButton
                        isCollapsed={isCollapsed}
                        onClick={onToggle}
                    >
                        <Text
                            fontVariant="input2"
                            color={colorsPalettes.carbon[300]}
                            textDecoration={"underline"}
                        >
                            {translate(isCollapsed ? "si.common.show_more" : "si.common.show_less")}
                        </Text>

                        <SWReactIcons
                            iconName="arrow"
                            size="10px"
                            iconColor={colorsPalettes.carbon[200]}
                        />
                    </StyledShowMoreButton>
                )}
                isInlineToggle={false}
            />
        </Text>
    );
};

export default Description;
